import React from 'react';
import classNames from 'classnames';
import { isAudioElement, isVideoElement } from '@src/slide/domain/ui-model/elements/element-judge';
import { IAnimModel } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import { TimeIndefinite } from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';
import i18n from '@i18next/i18n';
import Style from '../index.less';
import { AnimType } from '@tencent/slide-sdk-model';
import MediaAnimItemProperty, {
    MediaAnimPropertyType,
} from '@com/animation-editor/animationItem/components/media-anim-item-property';

interface MediaAnimModifyParams {
    audio?: { repeatCount?: string, numSld?: number }
}

interface MediaAnimItemBoardProps {
    visible?: boolean;
    isShown?: boolean
    contentHeight: number
    animationModel: IAnimModel;
    onAnimEnd?: () => void;
    onModify?: (params: MediaAnimModifyParams) => void
}
const MediaAnimItemBoard = (props: MediaAnimItemBoardProps) => {
    const { visible, isShown, contentHeight, onAnimEnd, onModify, animationModel } = props;

    const handleAnimationEnd = () => {
        if (!isShown) {
            onAnimEnd?.();
        }
    };

    const handleVideoLoop = (b: boolean) => {
        onModify?.({ audio: { repeatCount: b ? TimeIndefinite : '' } });
    };

    const handleNumSld = (b: boolean) => {
        onModify?.({ audio: { numSld: b ? 999 : 0 } });
    };

    const mediaTypeJudge = {
        isAudio: isAudioElement(animationModel.elementModel),
        isVideo: isVideoElement(animationModel.elementModel),
    };

    const renderAnimProperty = () => {
        if (animationModel.props.animType === AnimType.Play) {
            return renderPlayAnimProperty();
        }
        return null;
    };

    const renderPlayAnimProperty = () => (
        <>
            {renderMediaAnimLoopSelect(mediaTypeJudge)}
            {renderMediaAnimNumSldSelect(mediaTypeJudge)}
        </>
    );

    const renderMediaAnimLoopSelect = (mediaTypeJudge) => {
        // 暂时只支持音频
        if (mediaTypeJudge.isAudio) {
            return (
                <MediaAnimItemProperty
                    title={i18n.t('循环播放')}
                    type={MediaAnimPropertyType.checkbox}
                    value={!!animationModel.audioRepeatCount}
                    onPropertyChange={checked => handleVideoLoop(!!checked)}
                />
            );
        }
        return null;
    };

    const renderMediaAnimNumSldSelect = (mediaTypeJudge) => {
        // 暂时只支持音频
        if (mediaTypeJudge.isAudio) {
            return (
                <MediaAnimItemProperty
                    title={i18n.t('跨页播放')}
                    type={MediaAnimPropertyType.checkbox}
                    value={!!animationModel.audioNumberedSlide}
                    onPropertyChange={checked => handleNumSld(!!checked)}
                />
            );
        }
        return null;
    };

    return (
        // 暂时只支持音频
        mediaTypeJudge.isAudio
            ? <div
                className={classNames(
                    Style['content-wrapper'],
                    {
                        [Style['content-wrapper-visible']]: visible,
                        [Style['content-wrapper-hidden']]: !visible,
                    },
                )}
                style={{ paddingTop: 0 }}
            >
                <div className={classNames(Style.content, {
                    [Style['content-show']]: isShown,
                    [Style['content-hide']]: !isShown,
                })}
                style={{ marginTop: isShown ? 0 : -contentHeight }}
                onTransitionEnd={handleAnimationEnd}
                >
                    {renderAnimProperty()}
                </div>
            </div>
            : null
    );
};

export default MediaAnimItemBoard;
